module.exports = __webpack_public_path__ + "img/10979922_L.48641698.png";